import React, { Component } from 'react'
import { connect } from 'react-redux'
import GameSelectors from '../../actions/game/game-selectors'
import LoadingIndicator from '../common/LoadingIndicator'
import './game-players-cp.css'


class GamePlayersCP extends Component {
  constructor() {
    super()
    
    this.hourglassEle = (
      <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-hourglass-split" viewBox="0 0 16 16">
        <path d="M2.5 15a.5.5 0 1 1 0-1h1v-1a4.5 4.5 0 0 1 2.557-4.06c.29-.139.443-.377.443-.59v-.7c0-.213-.154-.451-.443-.59A4.5 4.5 0 0 1 3.5 3V2h-1a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-1v1a4.5 4.5 0 0 1-2.557 4.06c-.29.139-.443.377-.443.59v.7c0 .213.154.451.443.59A4.5 4.5 0 0 1 12.5 13v1h1a.5.5 0 0 1 0 1h-11zm2-13v1c0 .537.12 1.045.337 1.5h6.326c.216-.455.337-.963.337-1.5V2h-7zm3 6.35c0 .701-.478 1.236-1.011 1.492A3.5 3.5 0 0 0 4.5 13s.866-1.299 3-1.48V8.35zm1 0v3.17c2.134.181 3 1.48 3 1.48a3.5 3.5 0 0 0-1.989-3.158C8.978 9.586 8.5 9.052 8.5 8.351z"></path>
      </svg>
    )

    this.hourglassSideEle = (
      <svg xmlns="http://www.w3.org/2000/svg" width="1.5em" height="1.5em" fill="currentColor" className="bi bi-hourglass-split" viewBox="0 0 16 16">
        <path d="M1.5,14C1.2,14,1,13.8,1,13.5v-11C1,2.2,1.2,2,1.5,2S2,2.2,2,2.5v1h1c1.7,0,3.3,1,4.1,2.6c0.1,0.3,0.4,0.4,0.6,0.4h0.7
          c0.2,0,0.5-0.2,0.6-0.4c0.7-1.6,2.3-2.6,4.1-2.6h1v-1C14,2.2,14.2,2,14.5,2S15,2.2,15,2.5v11c0,0.3-0.2,0.5-0.5,0.5S14,13.8,14,13.5
          v-1h-1c-1.7,0-3.3-1-4.1-2.6C8.8,9.7,8.6,9.5,8.4,9.5H7.7c-0.2,0-0.5,0.2-0.6,0.4c-0.7,1.6-2.3,2.6-4.1,2.6H2v1
          C2,13.8,1.8,14,1.5,14z M2,8.5h12v-4h-1c-1.3,0-2.6,0.8-3.2,2c-0.3,0.5-0.8,1-1.5,1H7.6c-0.7,0-1.2-0.5-1.5-1c-0.6-1.2-1.8-2-3.2-2
          H2V8.5z"/>
      </svg>
    )

    // this.hourglassDoneEle = (
    //   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.38 17.59">
    //     <polyline style={{fill:'none', stroke:'currentColor', strokeLinecap:'round', strokeMiterlimit:'10', strokeWidth:'5.58px',}} points="17.59 2.79 6.74 13.64 2.79 9.7"/>
    //   </svg>
    // )
    this.hourglassDoneEle = (
      <div style={{position:'relative', width:'1.5em', height:'2em',}}>
        <div className='bcioCheckmark' style={{top:'0.375em', borderColor: 'unset',}}></div>
      </div>
    )
  }

  render() {
    if (this.props.phaseType && this.props.phaseType === 'GAME_OVER') {
      return <div style={{textAlign: 'center'}}>Game Over</div>
    }
    if (!this.props.gamePlayerList.length || !this.props.actionsByUser) {
      return (
        <LoadingIndicator />
      )
    }

    let rows = []
    this.props.gamePlayerList.forEach(player => {
      rows.push(this.renderPlayerRow(player))
    })
    return rows
  }

  renderPlayerRow(player) {
    let icon = this.hourglassSideEle
    if (this.props.actionsByUser[player.id]) {
      icon = this.hourglassEle
      // icon for turn submitted
      if (this.props.submittedPlayers[player.id]) {
        icon = this.hourglassDoneEle
      }
    }
    return (
      <div key={`player_${player.id}`} className='game-player'>
        <div className="game-players-name" style={{color: player.color}}>{player.name}</div>
        <div className="game-players-icon">{icon}</div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    actionsByUser: state.game?.gameState?.phase?.actions_by_user,
    submittedPlayers: state.game.submittedPlayers, 
    gamePlayerList: GameSelectors.getGamePlayerList(state),
    //final: state.game?.gameState?.final,
    phaseType: state.game?.gameState?.phase?.phase_type,
  }
}
  
const mapDispatchToProps = (dispatch) => {
  return {}
}
  
export default connect(mapStateToProps, mapDispatchToProps)(GamePlayersCP)
